module.exports = __webpack_public_path__ + "6fb72d9706dabd51308ce3abeb2f94c1.jpg";